import { render } from "./CheckboxOneWay.vue?vue&type=template&id=39a01fbe&scoped=true"
import script from "./CheckboxOneWay.vue?vue&type=script&lang=js"
export * from "./CheckboxOneWay.vue?vue&type=script&lang=js"

import "./CheckboxOneWay.vue?vue&type=style&index=0&id=39a01fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a01fbe"]])

export default __exports__